import * as React from 'react';

export const LoadingContext = React.createContext<{
  loading: boolean;
  setLoading: ((args0: boolean) => void) | null;
}>({
  loading: false,
  setLoading: null,
});
